import { render, staticRenderFns } from "./RoomError.vue?vue&type=template&id=0a01e9a8&"
import script from "./RoomError.vue?vue&type=script&lang=js&"
export * from "./RoomError.vue?vue&type=script&lang=js&"
import style0 from "./RoomError.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports